import React from 'react';
import { AuthUser } from './AppLayout';
import { UiFont, UiTheme } from '../../utils/uiTheme';

interface AppTopbarProps {
  title: string;
  subtitle: string;
  user: AuthUser | null;
  uiTheme: UiTheme;
  uiFont: UiFont;
  onToggleFont: () => void;
  onToggleTheme: () => void;
  onToggleSidebar: () => void;
  onLogout: () => void;
}

const AppTopbar: React.FC<AppTopbarProps> = ({
  uiTheme,
  uiFont,
  onToggleFont,
  onToggleTheme,
}) => {
  return (
    <header className="u2-viewSettings" aria-label="Настройки интерфейса">
      <div className="u2-toolbarGroup">
        <button
          type="button"
          className="u2-iconBtn"
          aria-label="Переключить шрифт (web/system)"
          title={`Шрифт: ${uiFont}`}
          onClick={onToggleFont}
        >
          <svg className="u2-ico lg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 20h16" />
            <path d="M6 20L10 4h4l4 16" />
            <path d="M8.5 14h7" />
          </svg>
        </button>

        <button type="button" className="u2-iconBtn" aria-label="Переключить тему" title="Light/Dark" onClick={onToggleTheme}>
          <svg className="u2-ico lg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {uiTheme === 'dark' ? (
              <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
            ) : (
              <path d="M12 2v2M12 20v2M4 12H2M22 12h-2M19.8 4.2l-1.4 1.4M5.6 18.4l-1.4 1.4M19.8 19.8l-1.4-1.4M5.6 5.6 4.2 4.2M12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12z" />
            )}
          </svg>
        </button>

      </div>
    </header>
  );
};

export default AppTopbar;


